import { BattlePassKeyType, deserializeData, MayNull } from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { battlePassKeySchema } from '@src/deserialize/yup/battlePass'
import graphql from '@src/graphql/query/getCurrentBattlePassKeyBalance'
import { useCallback, useState } from 'react'

const useGetCurrentBattlePassKeyBalance = (): Hook => {
  const [query, { loading }] = useLazyQuery(graphql)

  const [data, setData] = useState<Response>([])

  const fetch = useCallback(async (): Promise<Response> => {
    const response = await query()

    const keyInfos = deserializeData<Response>(
      response,
      battlePassKeySchema,
      undefined,
      ['items']
    )

    setData(keyInfos)

    return keyInfos
  }, [query])

  return {
    fetch,
    data,
    loading
  }
}

type Response = MayNull<BattlePassKeyType[]>

type Hook = {
  fetch: () => Promise<Response>
  data: any
  loading: boolean
}

export default useGetCurrentBattlePassKeyBalance
